import React from 'react';

function Home() {
  return (
    <div className="home">
      {/* Blank body content as per requirements */}
    </div>
  );
}

export default Home; 